import { Organization } from "../../types/organization.types";
import { organizationAPI } from "../../services/organizationAPI";
import MicroModalSelectorSearch, { CustomViewPickerRender } from "../../../../common/components/organisme/MicroModalSelectorSearch/MicroModalSelectorSearch";
import useQuerySelector from "../../../../common/hooks/useQuerySelector";
import { ResponseAPIWithPagination } from "../../../../utils/genericAPI/API.types";
import React from "react";

export interface OrganizationPickerProps {
  currentOrganization?: Organization;
  setOrganization: (organization: Organization | undefined) => void;
  organizationId?: string;
  style?:  React.CSSProperties;
  customViewRender?:CustomViewPickerRender;
  label?: string;
}

export default function OrganizationPicker({
  currentOrganization,
  setOrganization,
  style,
  label
}: OrganizationPickerProps) {
  const {
    resultFound,
    isLoading,
    setValueQuery,
    valueQuery,
    isLoadingMore,
    setPage,
    lastPage,
    page,

  } = useQuerySelector<ResponseAPIWithPagination<Organization>>({
    getSearch: (query: string, page, pageSize) => {
      return organizationAPI.getAll({ search: query, page, pageSize });
    },
    addMoreResult(prev, next) {
      return {
        ...next.data,
        data: [...prev.data, ...next.data],
      };
    },
    extractLastPage: (result: ResponseAPIWithPagination<Organization>) =>
      result.pagination.total_pages,
    pageSize: 6,
  });

  return (
    <MicroModalSelectorSearch
      valueSelectedName={currentOrganization?.organization_name}
      placeholder="Sélectionner une organisation"
      valueQuery={valueQuery}
      setQuery={setValueQuery}
      result={
        resultFound?.data
          ? resultFound?.data?.map((item) => ({
              id: item.organization_id,
              name: item.organization_name,
              item,
            }))
          : []
      }
      onClickItem={(item) => {
        setOrganization(item.item);
      }}
      isLoading={isLoading}
      iconType="building"
      isLoadingMore={isLoadingMore}
      setPage={setPage}
      lastPage={lastPage || undefined}
      currentPage={page}
      style={style}
      label={label}
    />
  );
}
